import { gql } from '@/__generated__';

const RESEND_CREDENTIALS_GET_USER_INFO = gql(`#graphql
  query ResendCredentials_GetUserInfo($userId: Int!) {
    user(id: $userId) {
      id
      fullName
      email
    }
  }
`);

export default RESEND_CREDENTIALS_GET_USER_INFO;
